import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
} from "antd";
import { Document6 } from "./ReportDocuments/Document_6";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
//import { TableReportSup4 } from "./Tables/TableReportSup4";
const TableReportSup4 = React.lazy(() =>
  import("./Tables/TableReportSup4").then((module) => ({
    default: module.TableReportSup4,
  }))
);

const { RangePicker } = DatePicker;
const { Option } = Select;

class ReportSupReports4 extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    loading: false,
    downloadLoding: false,
    report_4_startDate: "",
    report_4_endDate: "",
    report4_loader: false,
    report4_List: [],
    report4_List_Total: 0,
    report4_API_loader: false,
    totalCriminal: 0,
  };

  downloadReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      cityId: user && user.cityId,
    };
    this.setState({
      report4_loader: true,
    });
    const blob = await pdf(
      <Document6
        rows={this.state.report4_List}
        filterDate={obj}
        allTotal={this.state.totalCriminal}
        total={this.state.report4_List_Total}
      />
    ).toBlob();

    if (blob) {
      this.setState({
        report4_loader: false,
      });
      saveAs(blob, "एकुण आरोपी");
    }
  };

  generatePDFReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      cityId: user && user.cityId,
    };
    this.setState({
      report4_API_loader: true,
    });
    professionalAction.getReport3(obj).then((res) => {
      res &&
        res &&
        res.text().then(async (text) => {
          const tempData = text && JSON.parse(text);
          const tempFilterData = _.filter(
            tempData && tempData.data && _.flatten(tempData.data),
            function (o) {
              return Object.keys(o).length !== 0;
            }
          );
          this.setState({
            report4_API_loader: false,
            report4_List: tempFilterData,
            report4_List_Total: tempData && tempData.totalCheckedCriminals,
            totalCriminal: tempData && tempData.totalAllCriminal,
          });
        });
    });
  };

  onFinishDateRangeGPSReport1 = (values) => {
    if (values) {
      this.setState({
        report_4_startDate: values.toISOString(),
      });
    }
  };

  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { professionals } = this.props;
    const { pc_cities, loading } = professionals;

    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            className="site-page-header"
            ghost={false}
            onBack={false}
            title={user && user.userid}
            subTitle={
              user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
            }
          ></PageHeader>
          <PageHeader
            className="site-page-header"
            ghost={false}
            onBack={false}
            title={"गस्त Report"}
            extra={[
              <Button
                key="1"
                type="primary"
                disabled={!this.state.report4_List.length}
                loading={this.state.report4_loader}
                onClick={this.downloadReport1}
              >
                Download
              </Button>,
            ]}
          >
            <Descriptions size="small" column={2}>
              <Descriptions.Item label="Select Date">
                <DatePicker
                  style={{ marginRight: 10 }}
                  onChange={(val) => this.onFinishDateRangeGPSReport1(val)}
                  inputReadOnly
                />
                {/* <DatePicker  style={{marginRight:10}} onChange={val => this.onFinishDateRangeGPSReport1(val)} /> */}
                <Button
                  key="1"
                  type="primary"
                  disabled={!this.state.report_4_startDate}
                  loading={this.state.report4_API_loader}
                  onClick={this.generatePDFReport1}
                >
                  Find
                </Button>
              </Descriptions.Item>
            </Descriptions>
          </PageHeader>
          <React.Suspense fallback={<div>Loading...</div>}>
            <TableReportSup4
              data={this.state.report4_List}
              allTotal={this.state.totalCriminal}
              total={this.state.report4_List_Total}
            ></TableReportSup4>
          </React.Suspense>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedReports4 = connect(mapStateToProps)(ReportSupReports4);
export { connectedReports4 as ReportSupReports4 };
